// extracted by mini-css-extract-plugin
export default {"button":"CartButton_button__od56f","icon":"CartButton_icon__jJi8V","badge":"CartButton_badge__85LKe","bump":"CartButton_bump__5eHdz"};